export default {"src":"/_next/static/media/favorites-empty-annsacks.54cd777a.svg","height":14,"width":15};